export default "__VITE_ASSET__CGGg0pjr__"